import { createContext } from 'react';
import { ChannelTypes } from 'store/types/channeTypes';
import { CheckDigitPolicy } from 'store/types/checkDigitPolicy';
import { ConfigurationState } from 'services/Configuration';
import { CustomBranding } from '@ds/ui';
import { Branding, defaultBranding } from 'store/types/branding';

export interface IVerifyApplicationContext {
    customBranding: CustomBranding | undefined;
    branding: Branding;
    isDocumentLocked: boolean;
    language: string;
    displayChannel: ChannelTypes;
    phoneNumberDigitCheck: CheckDigitPolicy;
    configurationState: ConfigurationState;
    exception: any;
}

const VerifyApplicationContext = createContext<IVerifyApplicationContext>({
    customBranding: undefined,
    branding: defaultBranding,
    isDocumentLocked: false,
    language: '',
    displayChannel: 'SMSandPhoneCall',
    phoneNumberDigitCheck: 'None',
    configurationState: 'Error',
    exception: undefined
});

export default VerifyApplicationContext;
